export default "__VITE_ASSET__421827da__"